<template>
  <div>
    <location-schedule-item
      v-for="day in days"
      :key="day.key"
      :keyName="day.key"
      :label="day.label"
      v-bind:value="day.value"
      v-on:change="updateData"
      :limit="limit"
      :add-text="addText"
    />
  </div>
</template>

<script>
import LocationScheduleItem from '@/views/Locations/Components/LocationScheduleItem';

export default {
  components: {
    LocationScheduleItem
  },
  name: 'LocationScheduleList',
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Object,
    addText: {
      type: String,
      default: 'Adicionar'
    },
    bulkUpdate: Boolean
  },
  methods: {
    change() {
      this.$emit('change', this.items);
      if (this.bulkUpdate) {
        this.$emit('savePayload', 'regular_hours',  this.items);
        this.open = false
      }
    },
    updateData(value) {
      this.items[value.key] = value.data
      this.change()
    }
  },
  data: () => ({
    itemSelected: '',
    open: true,
    items: [],
    days: []
  }),
  created() {
    if (this.value) {
      this.items = JSON.parse(JSON.stringify(this.value))
    }
  },
  mounted() {
    const days = {
      MONDAY: 'Segunda-feira',
      TUESDAY: 'Terça-feira',
      WEDNESDAY: 'Quarta-feira',
      THURSDAY: 'Quinta-feira',
      FRIDAY: 'Sexta-feira',
      SATURDAY: 'Sábado',
      SUNDAY: 'Domingo'
    }
    let newDays = []
    for (const key in days) {
      const label = days[key]
      const value = this.value ? this.value[key] : null
      newDays.push({ key, label, value })
    }
    this.days = newDays
  },
  watch: {
    itemSelected(val) {
      this.items.map((item, index) => {
        item.selected = index === val
        return item
      });
      this.change()
    },
    value(value) {
      if (value) this.items = value
    }
  }
};
</script>

<style scoped>
.action-cols {
  min-width: 56px;
}
</style>
